import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * 문의 페이지 (/contact)
 * 애드센스 "사이트 신뢰성/연락처 제공" 요건 충족용.
 */

const SITE_NAME = 'CBT 편의점';
const SITE_DOMAIN = 'www.cbtstudy.com';
const SITE_CONTACT = 'support@cbtstudy.com';

function Section({ title, children }) {
  return (
    <section className="mb-8">
      <h2 className="text-xl font-bold text-gray-900 mb-3">{title}</h2>
      <div className="text-gray-700 leading-relaxed space-y-2">{children}</div>
    </section>
  );
}

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Helmet>
        <title>문의하기 - {SITE_NAME}</title>
        <meta
          name="description"
          content={`${SITE_NAME}에 문의하기. 기출문제 오류 제보, 서비스 이용 문의, 제휴·광고 문의를 받습니다.`}
        />
        <link rel="canonical" href={`https://${SITE_DOMAIN}/contact`} />
      </Helmet>

      <header className="bg-white border-b border-gray-200">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center justify-between">
          <a href="/" className="text-lg font-bold text-gray-900">{SITE_NAME}</a>
          <a href="/" className="text-sm text-orange-500 hover:text-orange-600 transition-colors">← 홈으로</a>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-10">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">문의하기</h1>
        <p className="text-sm text-gray-500 mb-10">{SITE_NAME} 운영팀에 문의해 주세요.</p>

        <p className="text-gray-700 leading-relaxed mb-8">
          서비스 이용 중 궁금한 점, 기출문제·해설의 오류, 제휴 및 광고 문의 등
          무엇이든 아래 이메일로 연락해 주시면 확인 후 답변드리겠습니다. 보내주신
          오류 제보는 콘텐츠 품질 개선에 큰 도움이 됩니다.
        </p>

        <Section title="이메일 문의">
          <p>
            <a href={`mailto:${SITE_CONTACT}`} className="text-orange-600 underline text-lg">{SITE_CONTACT}</a>
          </p>
          <p>보통 영업일 기준 2~3일 이내에 답변드립니다.</p>
        </Section>

        <Section title="이런 내용을 보내주세요">
          <ul className="list-disc pl-5 space-y-1">
            <li><strong>오류 제보:</strong> 자격증명·연도·회차·문제 번호와 함께 어떤 부분이 잘못되었는지</li>
            <li><strong>이용 문의:</strong> 사용 중 겪은 불편이나 기능 관련 질문</li>
            <li><strong>제휴·광고 문의:</strong> 협업이나 광고 관련 제안</li>
          </ul>
        </Section>

        <Section title="자주 묻는 질문">
          <p><strong>Q. 회원가입을 해야 이용할 수 있나요?</strong></p>
          <p>아니요. 로그인 없이도 모든 기출문제를 무료로 풀 수 있습니다. 로그인하면 학습 기록을 여러 기기에서 동기화할 수 있습니다.</p>
          <p className="pt-2"><strong>Q. 문제의 정답이 공식 발표와 다른 것 같아요.</strong></p>
          <p>최종 정답은 시험 시행 기관의 공식 발표를 따릅니다. 차이를 발견하시면 위 이메일로 제보해 주세요. 검토 후 수정합니다.</p>
        </Section>

        <div className="border-t border-gray-200 mt-10 pt-6 text-sm text-gray-500 flex flex-wrap gap-4">
          <a href="/about" className="hover:text-orange-600">서비스 소개</a>
          <a href="/privacy" className="hover:text-orange-600">개인정보처리방침</a>
          <a href="/terms" className="hover:text-orange-600">이용약관</a>
          <a href="/contact" className="hover:text-orange-600">문의</a>
        </div>
      </main>
    </div>
  );
}
